module.exports = __webpack_public_path__ + "img/news-10.d6ae74f2.png";